import React, { useState, useEffect } from "react";
import Classes from "./Hero2.module.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import backend from "../../../../../../../api";

export default function Hero2() {
  const navigateTo = useNavigate();
  const { user, token } = useSelector((state) => state.auth);
  const [mentors, setMentors] = useState([]);
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const userRole = user?.role

  async function fetchMentors() {
    try {
      const response = await backend.get(`/api/user?role=mentor`)
      console.log(response);
      // Filter and prioritize mentors
      const allMentors = response.data?.data || [];
      const prioritizedMentors = allMentors
        .filter((mentor) => mentor.mentorProfile?.basicInfo?.name) // Exclude mentors without a name
        .sort((a, b) => {
          const aHasPhoto = !!a.mentorProfile?.basicInfo?.avatar;
          const bHasPhoto = !!b.mentorProfile?.basicInfo?.avatar;
          // Prioritize mentors with both name and photo
          if (aHasPhoto && !bHasPhoto) return -1;
          if (!aHasPhoto && bHasPhoto) return 1;
          return 0;
        })
        .slice(0, 3); // Limit to 3 mentors
      setMentors(prioritizedMentors);
    } catch (err) {
      console.error("Error fetching mentors:", err);
      setError(err.response?.data?.message || "Failed to load mentors");
    }
  }

  async function fetchConversations() {
    try {
      const response = await backend.get(`/api/chat/conversation?userId=${user._id}`);
      const convos = (response.data?.data || [])
        .filter((convo) => convo.last?.text && convo.last.text.trim() !== "") // Only include conversations with non-empty messages
        .slice(0, 3); // Limit to 3 recent messages
      setConversations(convos);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching conversations:", err);
      setError(err.response?.data?.message || "Failed to load messages");
      setLoading(false);
    }
  }

  useEffect(() => {
    if (user._id && user.role === "mentee") {
      fetchMentors();
      fetchConversations();
    }
  }, [user._id, user.role, token]);



  console.log(mentors);

  return (
    <div className={Classes.hero}>
      {/* Left column */}
      <div>
        <div className="title">
          <h4>Recommended Mentors</h4>
          <hr />
        </div>

        <div className={Classes.box}>
          <div className={Classes.profileCon}>
            {loading ? (
              <div className={Classes.center} >
                <h5 className="placeholderText" >Loading...</h5>
              </div>
            ) : mentors.length === 0 ? (
              <div className={Classes.center} >
                <h5 className="placeholderText" >No mentors available</h5>
              </div>
            ) : (
              mentors.map((mentor) => (
                <div key={mentor._id} className={Classes.profileCard}>
                  <div>
                    <div className={Classes.card_img}>
                      <img
                        src={mentor.mentorProfile?.basicInfo?.avatar || "/assets/images/user.png"}
                        className={Classes.card_inner_img}
                        alt={mentor.mentorProfile?.basicInfo?.name || "Mentor Name"}
                      />
                    </div>
                  </div>
                  <div className={Classes.widthInherit}>
                    <div className={Classes.flexBetween}>
                      <div>
                        <h5 className={Classes.text1}>{mentor.mentorProfile?.basicInfo?.name || "Mentor Name"}</h5>
                      </div>
                      <div>
                        <button
                          className={Classes.cardBtn}
                          onClick={() => navigateTo(`/mentor/view-profile/${mentor._id}`)}
                          style={{ marginBottom: "5px" }}
                        >
                          <h5>View Profile</h5>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>


      <div>
        <div className="title">
          <div>
            <h4>Recent Messages</h4>
            <h5 onClick={() => navigateTo('/messages')} style={{ color: "#e15757", cursor: "pointer" }}>
              View all
            </h5>
          </div>
          <hr />
        </div>

        <div className={Classes.box}>
          {loading ? (
            <div className={Classes.center} >
              <h5 className="placeholderText" >Loading...</h5>
            </div>
          ) : <>
            {conversations && conversations.length > 0 ? (
              <ul className={Classes.messageList}>
                {conversations.map((convo) => (
                  <li key={convo._id} className={Classes.messageItem}>
                    <img
                      src={convo.partnerAvatar || "https://i.pravatar.cc/80"}
                      alt={convo.partnerName}
                      className={Classes.avatar}
                    />
                    <div className={Classes.messageBody}>
                      <h5 className={Classes.name}>{convo.partnerName || "Unknown"}</h5>
                      <h5 className={Classes.snippet}>{convo.last.text}</h5>
                      <h5 className={Classes.time}>
                        {new Date(convo.last.createdAt).toLocaleString([], {
                          month: "short",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </h5>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <div className={Classes.emptyMessage} >
                <img src='/assets/images/empty-message.png' alt="empty" draggable={false} />
                <h5>No recent messages</h5>
              </div>
            )}
          </>
          }

        </div>
      </div>

    </div>
  );
}